import React from 'react'
import { WrapRoot } from './src/components/wrap-root'
import 'web-animations-js/web-animations.min'

export const wrapRootElement = ({ element }) => (
  <>
    <WrapRoot element={element} />
  </>
)
